
import AppShell from "@/components/AppShell";
import { FriendsMobileNav } from "@/components/friends/FriendsMobileNav";
import { FriendsDesktopNav } from "@/components/friends/FriendsDesktopNav";
import { useTranslation } from "react-i18next";

const Friends = () => {
  const { t } = useTranslation('friends');
  
  return (
    <AppShell showHeader={false} backgroundGradient="linear-gradient(154deg, #9edfff 2%, rgb(191, 234, 255) 26%, rgb(212, 204, 255) 100%)">
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold text-uplivion-blue mb-6">{t('title')}</h1>
        
        {/* Mobile Navigation - visible on small screens */}
        <div className="friends-mobile-nav">
          <FriendsMobileNav />
        </div>
        
        {/* Desktop Navigation - visible on large screens */}
        <div className="friends-desktop-nav">
          <FriendsDesktopNav />
        </div>
      </div>
    </AppShell>
  );
};

export default Friends;
